module.exports = function encodeForUrl (text, encode = true) {
    if (!text) return 'brak'
    return encode ? encodeURIComponent(text) : text
}